import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import {
  SENSEMAKER_LIST_FILTER_GAP_PX,
  SENSEMAKER_LIST_FILTER_WIDTH_PX,
  SENSEMAKER_LIST_PILL_GAP_PX,
  SENSEMAKER_LIST_PILLS_TO_GRID_GAP_PX,
  SENSEMAKER_LIST_TITLE_ROW_TO_PILLS_GAP_PX,
  SENSEMAKER_LIST_TITLE_SUBTITLE_GAP_PX,
} from '@/features/tenants/lib/sensemaker-list-layout'
import { SP_LIST_TABLE_RADIUS_PX } from '../lib/signal-provider-list-layout'

export function SignalProviderListPageSkeleton() {
  return (
    <Box data-testid="signal-provider-list-page-skeleton" aria-busy aria-label="Loading signal providers">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
          mb: `${SENSEMAKER_LIST_TITLE_ROW_TO_PILLS_GAP_PX}px`,
        }}
      >
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Skeleton variant="text" width={220} height={32} />
            <Skeleton variant="rounded" width={160} height={26} sx={{ borderRadius: '100px' }} />
          </Box>
          <Box sx={{ mt: `${SENSEMAKER_LIST_TITLE_SUBTITLE_GAP_PX}px` }}>
            <Skeleton variant="text" width={360} height={20} />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: `${SENSEMAKER_LIST_FILTER_GAP_PX}px`,
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
          }}
        >
          <Skeleton variant="rounded" width={120} height={42} sx={{ borderRadius: '10px' }} />
          <Skeleton
            variant="rounded"
            width={SENSEMAKER_LIST_FILTER_WIDTH_PX}
            height={42}
            sx={{ borderRadius: '10px' }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: `${SENSEMAKER_LIST_PILL_GAP_PX}px`,
          mb: `${SENSEMAKER_LIST_PILLS_TO_GRID_GAP_PX}px`,
        }}
      >
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rounded" width={120} height={32} sx={{ borderRadius: '100px' }} />
        ))}
      </Box>
      <Skeleton variant="rounded" width="100%" height={400} sx={{ borderRadius: `${SP_LIST_TABLE_RADIUS_PX}px` }} />
    </Box>
  )
}
